import React from 'react';
import { useIntl } from 'react-intl';

import { getSetting } from '../helpers/Settings';

const PoweredBy = () => {
  const intl = useIntl();

  if (getSetting('hide_stockpress_branding_shares') || getSetting('cs1')) {
    return null;
  }

  return (
    <div className="powered-by-wrapper">
      <a className="powered-by" href="https://stockpress.co/pl-sign-up/" target="_blank" rel="noreferrer">
        <span>{intl.formatMessage({ defaultMessage: 'Powered by' })}</span>
        <img
          src="/images/stockpress-logo-alt-v2.png"
          alt="Stockpress"
        />
      </a>
    </div>
  );
};

export default PoweredBy;
